import { useLocation } from 'react-router-dom';
import { Loader } from '@hopskipdrive/react-components';
import { useQueryClient } from '@tanstack/react-query';

import { User } from '../auth/types/user';
import { LaunchDarklyProvider } from '../shared/contexts/LDContext';
import AccessDenied from '../shared/pages/AccessDenied';
import NotFound from '../shared/pages/NotFound';

export const ProtectedRoute = ({ roles, children }): JSX.Element => {
  const queryClient = useQueryClient();
  const response = queryClient.getQueryState<User>(['getAuth']);

  const location = useLocation();

  if (!response?.data) {
    window.location.assign(`https://${window.env?.CARE_BASE_DOMAIN}`);

    return <Loader />;
  }

  if (location?.state && location.state.notFound) {
    return <NotFound />;
  }

  if (Array.isArray(roles) && roles.filter((item) => response?.data?.roles?.includes(item)).length === 0) {
    return <AccessDenied />;
  }

  return <LaunchDarklyProvider userSlug={response?.data?.slug}>{children}</LaunchDarklyProvider>;
};
